import React, { useEffect, useState } from 'react'
import { observer, useLocalObservable } from "mobx-react-lite"
import Layout from '../layout/Layout'
import classes from './MyLibrary.module.scss'
import { MyLoopsModel, MyRecentPacksModel } from './model'
import LoopList from '../loops/LoopList'
import PackCard from '../common/PackPlayerCard'
import { TipsProvider } from '../loops/ctx'

import ChevronLeftIcon from '@mui/icons-material/ChevronLeft'
import ChevronRightIcon from '@mui/icons-material/ChevronRight'
import Button from '@mui/material/Button'
import { toJS } from 'mobx'

import PackList from '../common/PackList'


const MyRecentPacks = observer(() => {
  const[model, ] = useState(() => new MyRecentPacksModel())
  // const vm = useLocalObservable(() => ({
  //   listDom: null,
  //   scrollWidth: 0,
  //   scrollLeft: 0,
  //   clientWidth: 0,
  //   timeoutId: 0,
  //   setListDom(dom) {
  //     this.listDom = dom;
  //     if (dom) {
  //       setInterval(this.resetSize, 300);
  //     }
  //     else {
  //       clearInterval(this.timeoutId)
  //     }
  //   },
  //   resetSize() {
  //     if (!this.listDom) {
  //       return;
  //     }
  //     this.scrollWidth =  this.listDom.scrollWidth
  //     this.scrollLeft =  this.listDom.scrollLeft
  //     this.clientWidth =  this.listDom.clientWidth
  //     //console.log('reset ', this.scrollWidth, this.scrollLeft, this.clientWidth)
  //   },
  //   nextView() {
  //     this.listDom.scrollTo(this.listDom.clientWidth + this.listDom.scrollLeft, 0)
  //   },
  //   preView() {
  //     this.listDom.scrollTo(this.listDom.scrollLeft - this.listDom.clientWidth, 0)
  //   },
  //   get isPreEnabled() {
  //     if (this.listDom == null) {
  //       return true;
  //     }
  //     return this.scrollLeft == 0;
  //   },
  //   get isNextEnabled() {
  //     if (this.listDom == null) {
  //       return true;
  //     }
  //     return this.clientWidth + this.scrollLeft == this.scrollWidth;
  //   }
  // }))

  useEffect(() => {
    model.load()
  }, [])

  return <PackList title="Recently Used Packs" className={classes.packs} mode="inline" packs={model.packs} />
  
  // return <div className={classes.packs}>
  //   <div className={classes.packsHead}>
  //     <h2>Recently Used Packs</h2>
  //     <div>
  //     <Button size="small" aria-label="pre" variant="outlined" className={classes.navBtn} onClick={vm.preView} disabled={vm.isPreEnabled}>
  //       <ChevronLeftIcon />
  //     </Button>
  //     <Button size="small" aria-label="next" variant="outlined" className={classes.navBtn} onClick={vm.nextView} disabled={vm.isNextEnabled}>
  //       <ChevronRightIcon />
  //     </Button>
  //     </div>
  //   </div>
  //   <div className={classes.packList} ref={vm.setListDom}>
  //     <div className={classes.packItems}>
  //       {model.packs.map((pack) => {
  //         return <PackCard className={classes.packItem} key={pack.id} pack={toJS(pack)} />
  //       })}
  //     </div>
  //   </div>
  // </div>
})

const MyLibrary = observer(() => {
    const[model, ] = useState(() => new MyLoopsModel())

    useEffect(() => {
      model.load()
      window.addEventListener("beforeunload", model.commitDeleted)
      return () => {
        model.commitDeleted()
        window.removeEventListener("beforeunload", model.commitDeleted)
      }
    }, [model])

    const count = new Intl.NumberFormat().format(model.count)

    return <Layout title="My Library">
        <TipsProvider requiredTips={false}>
        <div className={classes.root}>
            <MyRecentPacks />
            <LoopList model={model} showCover={true} top={<div className={classes.title}>
            All My Loops
            </div>} barStart={<div className={classes.count}>{count} Loops</div>} />
        </div>
        </TipsProvider>
    </Layout>
})

export default MyLibrary
